/* SarhERP Project Copyright © 2021 SarhSoft All rights reserved M.Farhat */

import axios from 'axios';
const prefix = a => 'Panel/Assistance' + (a ? `/${a}` : '');
export default {
  index(params, config = {}) {
    const url = prefix();
    return params === true ? url : axios.get(url, {...config, params});
  },
  addReply(id = 0,data = {}, config = {}) {
    const url = prefix(`${id}/add_reply`);
    return data === true ? url : axios.post(url, data, config);
  },
  store(data = {}, config = {}) {
    const url = prefix();
    return data === true ? url : axios.post(url, data, config);
  },
  update(id, data = {}, config = {}) {
    const url = prefix(id);
    return id === true ? url : axios.put(url, data, config);
  },
  show(id, config = {}) {
    const url = prefix(id);
    return id === true ? url : axios.get(url, config);
  },
  showClosed(id, config = {}) {
    const url = prefix(`${id}?closed=1`);
    return id === true ? url : axios.get(url, config);
  },
  destroy(id, config = {}) {
    const url = prefix(id);
    return id === true ? url : axios.delete(url, config);
  },
  close(id, data = {}, config = {}) {
    const url = prefix(`${id}/close`);
    return data === true ? url : axios.post(url, data, config);
  }
};
